import { LawsuitInfo } from "@customTypes/responses/lawsuit";
import React from "react";
import CaseMovementsTab from "./CaseMovementsTab";
import LawsuitMovementsTab from "./LawsuitMovementsTab";
import HistoricalSkeleton from "@pages/skeletons/HistoricalSkeleton";
import { useQuery } from "react-query";

type MovementsTabProps = {
  lawsuitId: string;
};

const MovementsTab: React.FC<MovementsTabProps> = ({ lawsuitId }) => {
  const { isLoading, data: lawsuit } = useQuery<LawsuitInfo>(["getCase", lawsuitId]);

  if (isLoading) return <HistoricalSkeleton />;

  if (lawsuit.type === "CTE_CASE") return <CaseMovementsTab lawsuit={lawsuit} />;

  return <LawsuitMovementsTab lawsuit={lawsuit} />;
};

export default MovementsTab;
